/* HubRise OAuth "state" helpers.

   HubRise sends the user back to one fixed redirect URL with no location in
   it, so the location that started the connect travels in the OAuth `state`
   instead, together with a random value. The same value is kept in this tab's
   sessionStorage and has to match on the way back, so a forged callback can't
   attach a HubRise account to a location. */
const HUBRISE_OAUTH_STATE_KEY = "hubriseOAuthState";

// The one redirect URL path registered with HubRise. "hubrise" sits where a
// location id normally goes, because the location app only loads for
// /:locationId/presto-locations/... urls. It is a fixed word, not a location.
export const HUBRISE_REDIRECT_PATH =
  "/hubrise/presto-locations/integrations/redirect";

const createNonce = () => {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes)
    .map((byte) => ("0" + byte.toString(16)).slice(-2))
    .join("");
};

/* Creates the state for a new connect and remembers it for this tab. */
export const createHubriseOAuthState = (locationId: string) => {
  const nonce = createNonce();
  sessionStorage.setItem(
    HUBRISE_OAUTH_STATE_KEY,
    JSON.stringify({ locationId, nonce }),
  );
  return `${locationId}.${nonce}`;
};

/* Returns the location id when the state HubRise sent back matches the stored
   one, otherwise an empty string. */
export const readHubriseOAuthState = (state: string | null) => {
  let stored: any = null;
  try {
    stored = JSON.parse(sessionStorage.getItem(HUBRISE_OAUTH_STATE_KEY) || "null");
  } catch (e) {
    stored = null;
  }
  if (!state || !stored?.locationId || !stored?.nonce) return "";
  return state === `${stored.locationId}.${stored.nonce}` ? stored.locationId : "";
};

/* Forgets the stored state, so each one can only be used once. */
export const clearHubriseOAuthState = () => {
  sessionStorage.removeItem(HUBRISE_OAUTH_STATE_KEY);
};
